import React, { useEffect } from 'react'
import { keyBy } from 'lodash'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useEntities } from 'cityads-v3/hooks/entities'

import classes from './Account.scss'

import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined'
import IconButton from '@mui/material/IconButton'
import Step2 from 'cityads-v3/containers/welcomeform/Step2'
import SupportButton from 'cityads-v3/components/Buttons/SupportButton'
import Tooltip from 'cityads-v3/components/Tooltip/Tooltip'
import Typography from '@mui/material/Typography'
import { WebmasterVerificationStatus, WebmasterVerificationStatusId } from 'cityads-v3/types/header'
import { RootState } from 'cityads-v3/types/reducer'

export default function FormPersonal(): JSX.Element {
  const { t } = useTranslation(['Welcome', 'main'])
  const language = useSelector((state: RootState) => state.language.language)
  const xkey = useSelector((state: RootState) => state.header.user?.xkey ?? null)
  const verificationStatus = useSelector((state: RootState) => state.header.user?.verificationStatus ?? null)
  const trustLevelId = useSelector((state: RootState) => state.welcomeform.trustLevelId)
  const trustLevelsById = useSelector((state: RootState) => state.trustLevels.trustLevelsById)
  const [webmasterVerificationStatuses, , , loadWebmasterVerificationStatuses] = useEntities<WebmasterVerificationStatus[]>('webmasterVerificationStatuses')
  const webmasterVerificationStatusesById = keyBy(webmasterVerificationStatuses, 'id')

  useEffect(() => {
    loadWebmasterVerificationStatuses()
  }, [language])

  return (
    <div className={classes.formCard}>
      <div className={classes.items}>
        <div className={classes.item}>
          <Typography component="div" color="textSecondary" className={classes.itemTitle}>{t('trustLevel')}</Typography>
          <Typography component="div" className={classes.itemValue}>{trustLevelsById[trustLevelId]?.name}</Typography>
        </div>

        {xkey && (
          <div className={classes.item}>
            <Typography component="div" color="textSecondary" className={classes.itemTitle}>{t('xkey')}</Typography>
            <Typography component="div" className={classes.itemValue}>{xkey}</Typography>
          </div>
        )}

        <div className={classes.item}>
          <Typography component="div" color="textSecondary" className={classes.itemTitle}>{t('verificationStatus')}</Typography>
          <Typography component="div" className={classes.itemValue}>
            {webmasterVerificationStatusesById[verificationStatus]?.name}
            {(verificationStatus === WebmasterVerificationStatusId.NotVerified) ?
              (
                <>
                  {' '}
                  <Tooltip title={t('main:header.helpdesk')}>
                    <SupportButton
                      component={IconButton}
                      sx={{ margin: '-24px 0' }}
                    >
                      <HeadsetMicOutlinedIcon />
                    </SupportButton>
                  </Tooltip>
                </>
              )
              :
              null
            }
          </Typography>
        </div>
      </div>

      <Step2
        inline
        inlineClasses={{
          root: classes.inlineRoot,
          formItems: classes.formItems,
        }}
      />
    </div>
  )
}
